// Client-side mirror of the backend branching + flag logic.
export function computeFlags(questions, answers) {
  const byId = Object.fromEntries(questions.map((q) => [q.id, q]));
  const flags = new Set();
  for (const [qid, ans] of Object.entries(answers)) {
    const q = byId[qid];
    if (!q) continue;
    const opts = Object.fromEntries((q.options || []).map((o) => [o.value, o]));
    const vals = Array.isArray(ans) ? ans : [ans];
    for (const v of vals) {
      const o = opts[v];
      if (o && o.flags) o.flags.forEach((f) => flags.add(f));
    }
    const nonEmpty = ans != null && ans !== "" && !(Array.isArray(ans) && ans.length === 0);
    if (q.flags_on_answer && nonEmpty) q.flags_on_answer.forEach((f) => flags.add(f));
  }
  return flags;
}

function condTrue(cond, answers, flags) {
  if (!cond) return true;
  if (cond.any) return cond.any.some((c) => condTrue(c, answers, flags));
  if (cond.all) return cond.all.every((c) => condTrue(c, answers, flags));
  if (cond.flag) return flags.has(cond.flag);
  const ans = answers[cond.q];
  if (cond.in) return cond.in.includes(ans);
  if ("eq" in cond) return ans === cond.eq;
  if (cond.includes_any) {
    const vals = Array.isArray(ans) ? ans : ans ? [ans] : [];
    return cond.includes_any.some((v) => vals.includes(v));
  }
  if (cond.answered) return ans != null && ans !== "" && !(Array.isArray(ans) && ans.length === 0);
  return true;
}

export function visibleQuestions(questions, answers) {
  const flags = computeFlags(questions, answers);
  return questions.filter((q) => condTrue(q.condition, answers, flags));
}
